import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

/**
 * Reusable scroll-triggered fade-up reveal wrapper.
 * Usage: <Reveal delay={0.1}><YourContent /></Reveal>
 */
export default function Reveal({ children, delay = 0, y = 24, className }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.75, delay, ease: [0.2, 0.7, 0.2, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
